import React from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, parse, isValid, subYears, startOfToday } from "date-fns";
import { it, enGB } from "date-fns/locale";
import { TextField, ThemeProvider, createTheme } from "@mui/material";

const datePickerTheme = createTheme({
  palette: {
    primary: {
      main: "#bc2957",
      dark: "#bc2957",
      light: "#bc2957",
    },
  },
});

const GenericDatePicker = ({
  value,
  handleChange,
  errors,
  name,
  errorKey,
  languange,
}) => {
  const isEng = languange === "ENG";
  const locale = isEng ? enGB : it;
  const placeholder = isEng ? "DD/MM/YYYY" : "GG/MM/AAAA";

  const parsedValue = value ? parse(value, "yyyy-MM-dd", new Date()) : null;
  const validValue = parsedValue && isValid(parsedValue) ? parsedValue : null;

  const today = startOfToday();

  const isNascita =
    name === "birth_date" ||
    name?.includes("birth_date") ||
    name === "nascitaData" ||
    name?.includes("nascitaData");

  const isScadenza =
    name === "document.expiry_date" ||
    name?.includes("expiry_date") ||
    name === "documentoScadenza" ||
    name?.includes("documentoScadenza") ||
    name?.includes("titolareDocumentoScadenza");

  const isRilascio =
    name === "document.issue_date" || name?.includes("issue_date");

  const maxDate = isNascita
    ? subYears(today, 18)
    : isRilascio
      ? today
      : undefined;
  const minDate = isScadenza ? today : undefined;

  const handleDateChange = (date) => {
    if (!name) return;
    handleChange({
      target: {
        name,
        value: date && isValid(date) ? format(date, "yyyy-MM-dd") : "",
      },
    });
  };

  return (
    <ThemeProvider theme={datePickerTheme}>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={locale}>
        <DatePicker
          name={name}
          value={validValue}
          onChange={handleDateChange}
          format="dd/MM/yyyy"
          maxDate={maxDate}
          minDate={minDate}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              error={errors.includes(errorKey || name)}
              placeholder={placeholder}
              inputProps={{
                ...params.inputProps,
                placeholder,
                readOnly: true,
              }}
              sx={{
                marginTop: "0px",
                "& .MuiInputBase-input": { color: "#1b2838" },
                "& .MuiOutlinedInput-root": { borderRadius: "10px" },
                "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "rgba(0, 0, 0, 0.23)",
                  },
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                  {
                    borderColor: "rgba(0, 0, 0, 0.23)",
                    borderWidth: "1px",
                  },
                "& .MuiIconButton-root:hover": {
                  backgroundColor: "transparent",
                },
              }}
            />
          )}
          PopperProps={{ placement: "bottom-start" }}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default GenericDatePicker;
